import {
  faDroplet,
  faBolt,
  faFlask,
  faLeaf,
  faBox,
  faTrash,
  faRecycle,
  faRepeat,
  faGaugeHigh,
  faTriangleExclamation,
  faClock,
  faUsers,
  faChartSimple,
  faWheelchair,
  faHouse,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";

/**
 * Peta nama ikon indikator ke ikon FontAwesome.
 *
 * Field `icon` pada indicator_definition berisi NAMA, bukan berkas gambar,
 * supaya menambah indikator lewat Indicator Settings tidak perlu mengunggah
 * apa pun. Nama yang sama dipakai aplikasi mobile (dipetakan ke aset PNG di
 * `nyonyaa-apps/src/Assets/icon/`), jadi satu indikator tampil dengan lambang
 * yang sama di dashboard admin maupun di receipt customer.
 *
 * Menambah ikon baru: tambahkan di kedua peta itu, lalu nama barunya bisa
 * langsung dipilih dari form indikator.
 */
const PETA = {
  droplet: faDroplet,
  zap: faBolt,
  flask: faFlask,
  leaf: faLeaf,
  package: faBox,
  trash: faTrash,
  recycle: faRecycle,
  repeat: faRepeat,
  gauge: faGaugeHigh,
  alert: faTriangleExclamation,
  clock: faClock,
  users: faUsers,
  accessible: faWheelchair,
  home: faHouse,
  new: faUserPlus,
};

/** Nama ikon yang dikenal — dipakai dropdown di form indikator. */
export const daftarIkon = Object.keys(PETA);

/**
 * Ikon untuk sebuah nama. Nama yang tidak dikenal jatuh ke ikon netral,
 * bukan ke ikon acak: lambang yang keliru lebih menyesatkan daripada lambang
 * yang tidak berarti apa-apa.
 */
export const ikonIndikator = (nama) => PETA[nama] || faChartSimple;

export default PETA;
